<ng-container *transloco="let t">
  <div class="completed-connection-step">
    <main class="step-content" [attr.aria-busy]="loadingEntity">
      <button
        class="back-button"
        type="button"
        [attr.aria-label]="t('lang.back')"
        (click)="back.emit()">
        <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
      </button>

      @if (loadingEntity) {
        <div class="completed-connection-skeleton" aria-hidden="true">
          <div class="skeleton skeleton-brand"></div>
          <div class="skeleton skeleton-title"></div>
          <div class="skeleton skeleton-description"></div>
          <div class="skeleton skeleton-banner"></div>
          <div class="skeleton skeleton-row"></div>
          <div class="skeleton skeleton-row"></div>
          <div class="skeleton skeleton-note"></div>
        </div>
      } @else {
        <div class="completed-connection-content">
          <header class="header-section">
            <lib-connection-entity-brand-chip
              [displayName]="entityName"
              [iconUrl]="entityIconUrl" />

            <h1 class="step-title">
              {{ t('lang.credentials_title') }}
            </h1>
            <p class="step-description">
              {{
                t('lang.credentials_description', {
                  pro: entityName,
                })
              }}
            </p>
          </header>

          <section class="completion-banner" role="status">
            <span class="completion-icon" aria-hidden="true">
              <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
            </span>
            <strong>{{ t('lang.connection_completed_banner_title') }}</strong>
          </section>

          <div class="credential-fields">
            @if (hasResolvedCredentialFields) {
              @for (field of credentialFields; track field.controlName) {
                <div class="mz-form-row vertical for-text">
                  <div class="mz-label">
                    <label [for]="'completed-' + field.controlName">
                      {{ getFieldLabel(field) }}
                      @if (field.required) {
                        <span class="required">*</span>
                      }
                    </label>
                  </div>
                  <div class="mz-input">
                    <div class="mz-input-container">
                      <input
                        [id]="'completed-' + field.controlName"
                        [type]="field.inputType"
                        [placeholder]="protectedCredentialPlaceholder"
                        disabled
                        aria-readonly="true" />
                      @if (isPasswordField(field)) {
                        <button
                          type="button"
                          class="icon eye-toggle"
                          disabled
                          tabindex="-1"
                          aria-hidden="true">
                          <mzic-svg src="assets/icons/mzic-eye.svg" />
                        </button>
                      }
                    </div>
                  </div>
                </div>
              }
            } @else {
              <div class="mz-form-row vertical for-text">
                <div class="mz-label">
                  <label for="completed-credentials-fallback">
                    {{
                      t('lang.connection_completed_credentials_fallback_label')
                    }}
                  </label>
                </div>
                <div class="mz-input">
                  <div class="mz-input-container">
                    <input
                      id="completed-credentials-fallback"
                      type="text"
                      [placeholder]="protectedCredentialPlaceholder"
                      disabled
                      aria-readonly="true" />
                  </div>
                </div>
              </div>
            }
          </div>

          <aside class="info-note">
            <mzic-svg src="assets/icons/mzic-info.svg" />
            <p>{{ t('lang.credentials_info_note') }}</p>
          </aside>
        </div>
      }
    </main>

    <footer class="action-buttons">
      <button class="continue-button" type="button" (click)="continue.emit()">
        {{ t('lang.continue') | uppercase }}
      </button>
    </footer>
  </div>
</ng-container>
